import Game from "./Game.js";

export default class Game_Feedback
{
    /**
     * @param {Game} scene 
     */
    constructor(scene)
    {
        this.scene = scene;
        this.correctLetters = [];

        let positions = [  
            {x: -290, y: 0},
            {x: -205, y: -35},
            {x: -110, y: -70},
            {x: -20, y: -80},
            {x: 65, y: -80},
            {x: 145, y: -65},
            {x: 235, y: -30},
            {x: 290, y: 10},
        ];

        for(let i = 0; i < 8; i++)
        {
            let pos = positions[i];
            let letter = this.scene.addImage(pos.x, pos.y, "correct_" + i);
            letter.curY = 0;
            this.correctLetters.push(letter);

            letter.emitter = this.scene.add.particles(this.scene.defaultAtlas).createEmitter({
                frame: ['particle'],
                x: pos.x + 650,
                y: pos.y + 400,
                scale: {start: 1.2, end: 0},
                speed: {min: -100, max: 100},
                quantity: 120
            });

            letter.alpha = 0;
            letter.emitter.setEmitZone({
                source: new Phaser.Geom.Circle(0, 0, 50),
                type: 'random',
                quantity: 100
             });
            letter.emitter.stop();
        }

        this.correctContainer = this.scene.add.container(650, 400, this.correctLetters);
        this.correctContainer.setDepth(4);

        this.incorrectGraphic = this.scene.addImage(500, 400, "incorrect");
        this.incorrectGraphic.alpha = 0;
        this.incorrectGraphic.setDepth(3);

        this.amplitudeY = .8;
        this.frequency = .156;
        this.curStep = 0;
    }

    displayCorrect()
    {
        this.scene.playSound("correct");

        for(let i = 0; i < this.correctLetters.length; i++)
        {
            this.scene.addDelay(100 * i, () => {
                
                let letter = this.correctLetters[i];
                letter.setScale(0);
                this.scene.addTween(letter, 400, {alpha: 1, scaleX: 1, scaleY: 1, delay: 30}, "Back");

                letter.emitter.explode();
                letter.emitter.manager.depth = 3;
            });
        }

        this.scene.addDelay(1500, ()=>{
            for(let i = 0; i < this.correctLetters.length; i++)
            {
                this.scene.addDelay(100 * i, () => {
                    
                    let letter = this.correctLetters[i];
                    this.scene.addTween(letter, 400, {alpha: 0, scaleX: 0, scaleY: 0}, Phaser.Math.Easing.Sine.Out);
                });
            }
        });
    }

    displayIncorrect()
    {
        this.scene.playSound("incorrect");

        this.scene.killTween(this.incorrectGraphic);
        this.incorrectGraphic.x = 500;
        this.incorrectGraphic.alpha = 0;
        this.scene.addTween(this.incorrectGraphic, 800, {x: 650}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.scene.addTween(this.incorrectGraphic, 800, {x: 800}, Phaser.Math.Easing.Sine.In);
        });
        this.scene.addTween(this.incorrectGraphic, 300, {alpha: 1});
        this.scene.addTween(this.incorrectGraphic, 300, {alpha: 0, delay: 1200});
    }

    update()
    {
        this.curStep += this.frequency;
        for(let i = 0; i < this.correctLetters.length; i++)
        {
            let letter = this.correctLetters[i];
            letter.y += Math.cos(this.curStep + (i * 2)) * this.amplitudeY;
        }
    }   
}